function getPath(node, slug) {
    if (node.slug === slug) {
        return [];
    }
    if (Array.isArray(node.subMenu)) {
        for (const treeNode of node.subMenu) {
            const childResult = getPath(treeNode, slug);
            if (Array.isArray(childResult)) {
                return [treeNode.slug, ...childResult];
            }
        }
    }
}

function getMainItems(menuItem) {
    return menuItem ? menuItem.filter((item) => !item?.other) : [];
}

function getOtherItems(menuItem) {
    return menuItem ? menuItem.filter((item) => item?.other) : [];
}

export {
    getPath,
    getMainItems,
    getOtherItems,
};
